import Breadcrumbs from "@/components/Breadcrumbs";
import { useDataStore } from "@/stores";
import {
    alpha,
    Box,
    Button,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useTheme,
} from "@mui/material";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

const breadcrumbs = [
    {
        to: "../..",
        title: "Administration",
    },
    {
        title: "Settings",
        to: "../..",
    },
    {
        title: "Software",
        to: "",
    },
];

const Overview = () => {
    // const [data, setData] = useState<Array<SettingsSoftware>>([]);
    const software = useDataStore((state) => state.software);
    const data = useMemo(() => software["wip"], [software]);

    const theme = useTheme();
    const navigate = useNavigate();

    const renderStatus = (active: boolean) => {
        let statusColor = theme.palette.success;
        if (!active) statusColor = theme.palette.error;

        return (
            <Typography
                variant={"caption"}
                fontWeight={700}
                sx={{
                    bgcolor: alpha(statusColor.light, 0.1),
                    color: statusColor.dark,
                    paddingX: 1.5,
                    paddingY: 0.5,
                    borderRadius: 4,
                    display: "inline",
                }}
            >
                {active ? "Active" : "Inactive"}
            </Typography>
        );
    };

    return (
        <Box>
            <Breadcrumbs trail={breadcrumbs} />

            <Divider />

            <Grid container spacing={2} p={{ xs: 2, md: 4 }}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 750 }} aria-label="simple table">
                            <TableHead sx={{ bgcolor: "alternate.main" }}>
                                <TableRow>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            BIMQ Version
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Name
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }}>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Status
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }} />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data
                                    .sort((a, b) => a.order - b.order)
                                    .map((item, i) => (
                                        <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <TableCell component="th" scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {item.bimQLabel}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {item.name}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {renderStatus(item.active)}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row" sx={{ p: 0 }}>
                                                <Box sx={{ display: "flex" }}>
                                                    <Button
                                                        color={"primary"}
                                                        sx={{ ml: "auto", mr: 1 }}
                                                        onClick={() => navigate(`/admin/settings/software/${item.id}`)}
                                                    >
                                                        View
                                                    </Button>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Overview;
